import { render, staticRenderFns } from "./SfList.vue?vue&type=template&id=48004de8"
import script from "./SfList.vue?vue&type=script&lang=js"
export * from "./SfList.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfList.vue?vue&type=style&index=0&id=48004de8&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "f486fa74"
  
)

export default component.exports